import React, { useState } from 'react';
import { FiArrowRight, FiArrowLeft, FiCheck, FiGlobe, FiUsers, FiShield, FiMonitor, FiFileText } from 'react-icons/fi';
import { t, useLanguage } from '../useTranslations';
import storageAdapter from '../services/StorageAdapter';
import '../styles/OnboardingWizard.css';

const ONBOARDING_KEY = 'rms_onboarding_completed';

export const hasCompletedOnboarding = () => {
  return storageAdapter.getJSON(ONBOARDING_KEY, false) === true;
};

const STEPS = [
  {
    icon: <FiShield size={40} />,
    stepKey: 'welcome',
    color: 'var(--color-primary)',
  },
  {
    icon: <FiShield size={40} />,
    stepKey: 'bwra',
    color: 'var(--color-bwra)',
  },
  {
    icon: <FiGlobe size={40} />,
    stepKey: 'geoRisk',
    color: 'var(--color-georisk)',
  },
  {
    icon: <FiUsers size={40} />,
    stepKey: 'customerRisk',
    color: 'var(--color-customerrisk)',
  },
  {
    icon: <FiMonitor size={40} />,
    stepKey: 'txMon',
    color: 'var(--color-txmon)',
  },
  {
    icon: <FiFileText size={40} />,
    stepKey: 'complete',
    color: 'var(--color-success)',
  },
];

const OnboardingWizard = ({ onClose }) => {
  useLanguage();
  const [step, setStep] = useState(0);

  const handleComplete = () => {
    storageAdapter.setJSON(ONBOARDING_KEY, true);
    onClose();
  };

  const isLast = step === STEPS.length - 1;
  const current = STEPS[step];

  return (
    <div className="onboarding-overlay" role="dialog" aria-modal="true" aria-label={t('onboarding.title')}>
      <div className="onboarding-modal">
        {/* Progress dots */}
        <div className="onboarding-dots">
          {STEPS.map((_, i) => (
            <button
              key={i}
              className={`onboarding-dot ${i === step ? 'active' : ''} ${i < step ? 'done' : ''}`}
              onClick={() => setStep(i)}
              aria-label={`${t('onboarding.step')} ${i + 1}`}
            />
          ))}
        </div>

        {/* Step content */}
        <div className="onboarding-content">
          <div className="onboarding-icon" style={{ color: current.color }}>
            {current.icon}
          </div>
          <h2 className="onboarding-step-title">
            {t(`onboarding.steps.${current.stepKey}.title`)}
          </h2>
          <p className="onboarding-step-body">
            {t(`onboarding.steps.${current.stepKey}.body`)}
          </p>
        </div>

        {/* Navigation */}
        <div className="onboarding-nav">
          {step > 0 ? (
            <button className="onboarding-btn secondary" onClick={() => setStep(s => s - 1)}>
              <FiArrowLeft /> {t('onboarding.back')}
            </button>
          ) : (
            <button className="onboarding-btn ghost" onClick={handleComplete}>
              {t('onboarding.skip')}
            </button>
          )}

          {isLast ? (
            <button className="onboarding-btn primary" onClick={handleComplete}>
              <FiCheck /> {t('onboarding.getStarted')}
            </button>
          ) : (
            <button className="onboarding-btn primary" onClick={() => setStep(s => s + 1)}>
              {t('onboarding.next')} <FiArrowRight />
            </button>
          )}
        </div>

        <div className="onboarding-counter">
          {step + 1} / {STEPS.length}
        </div>
      </div>
    </div>
  );
};

export default OnboardingWizard;
